<template>
  <div class="location-block">
    <p class="location-block__title title" @click="emit('toggleFilter')">
      Местоположение
      <span v-if="searchStore.locationFilters" class="title_green">
        Указаны {{ searchStore.locationFilters }} параметр
      </span>
      <span v-else class="title_green">
        Не указаны
      </span>
      <ArrowIcon
        class="title__arrow"
        :class="{ 'title__arrow_active': visibleFiltersLocation }"
      />
    </p>

    <transition name="fade-slide">
    <div v-if="visibleFiltersLocation" class="location-block-wrapper">
      <div class="location-block__element">
        <p class="location-block__title">
          По метро
        </p>
        <pSelect
          v-model="searchStore.searchOptions.metroList"
          :selectionItems="metro"
          multiple
          placeholder="Выберите метро"
        />
      </div>

      <div class="location-block__element">
        <p class="location-block__title">
          Район
        </p>
        <pSelect
          v-model="searchStore.searchOptions.districtList"
          placeholder="Выберите район или поиск будет по всем районам"
          :selectionItems="districts"
          multiple
        />      
      </div>
    </div>
  </transition>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, Ref } from 'vue';
import pSelect from '@/common/pSelect/pSelect.vue'
import { useSearchStore } from "@/searchSection/store/searchStore";
import api from "@/myProfileSection/api";
import MetroItemResponse from '@/myProfileSection/types/MetroItemResponse';
import DistrictItemResponse from '@/myProfileSection/types/DistrictItemResponse';
import ArrowIcon from '@/common/icons/ArrowIcon.vue';


defineProps<{ visibleFiltersLocation: boolean }>();
const emit = defineEmits(['toggleFilter']);
const searchStore = useSearchStore()

const metro: Ref<MetroItemResponse[]> = ref([]);
const districts: Ref<DistrictItemResponse[]> = ref([]);
onMounted(async () => {
  try {
    const [metroList, districtsList] = await Promise.all([api.getMetroList(), api.getDistrictList()])
    metro.value = metroList
    districts.value = districtsList
  } catch (e) {
    window.showNotification('Произошла ошибка!', 'error')
  }
})

</script>

<style scoped lang="scss">
.location-block {
  grid-column: 1 / 3;

  &-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 12px;
    margin-top: 16px;

    @media screen and (max-width: 580px) {
      grid-template-columns: 1fr;
      gap: 15px;
    }
  }

  &__element {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .options {
    margin-top: 20px;

    &__list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;

      @media screen and (max-width: 580px) {
        flex-wrap: wrap;
        gap: 15px;
      }
    }
  }
}
</style>